import { FormSubmitButtons } from '../../composites/FormSubmitButtons';
import { BasicContainer } from '../../composites/containers/BasicContainer';
import { Spacer } from '../../parts/Spacer';

export const InformationActionsPage: React.FC<{
  title: string;
  texts: React.ReactNode;
  actions: React.ComponentProps<typeof FormSubmitButtons>['buttons'];
}> = ({ title, texts, actions }) => (
  <BasicContainer>
    <div className="text-h3 font-bold cst-halt leading-[1.4] text-main-100">
      {title}
    </div>
    <Spacer spacing={6} />
    <div className="text-base1 [&_a]:text-accent-primary [&_a]:underline">
      {texts}
    </div>
    <Spacer spacing={12} />
    <FormSubmitButtons buttons={actions} />
  </BasicContainer>
);
